/** Default destination when the user hits a site entry URL (`/`, `/home`, or unknown path). */
export function landingPathForUser(isLoggedIn: boolean): '/profile' | '/rules' {
  return isLoggedIn ? '/profile' : '/rules';
}
